module.exports = __webpack_public_path__ + "static/media/thewest-banner-summer-of-cricket.f8a5bdd3.png";